import styles from './Divider.module.css';

export const Divider = () => <div className={styles.divider} />;
